<template>
  <div class="leftNav">
    <div v-for="(sitem, sindex)  in navData" :key="sindex">
      <h3 v-if="sindex == 0">{{sitem.title}}</h3>
      <h3 v-else-if="sindex == 1" class="classList">{{sitem.title}}</h3>
      <h3 v-else-if="sindex == 2" class="classList">{{sitem.title}}</h3>
      <ul>
        <li v-for="(item,index) in sitem.child" :key="index" :class="{active: sindex == current[0] && index == current[1] }" @click="toggle(sindex, index, item)">
          <em class="work" v-if="sindex == 0"></em>
          <!-- <em class="iconReport" v-if="sindex == 1"></em> -->
          <em class="classNav" v-if="sindex == 1"></em>
          {{item.title}}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import fetch from "./../../fetch";
export default {
  data() {
    return {
      navData: [],
      current: [0, 0],
      isShow: true
    };
  },
  created() {
    this.$nextTick(() => {
      this.navData = [
        {
          title: "作业",
          child: [
            {
              title: "布置作业",
              path: "/web/selectGrade"
            },
            {
              title: "检查作业",
              path: "/web/home"
            }
          ]
        },
        // {
        //   title: '统计',
        //   child: [
        //     {
        //       title: "班级报告",
        //       path: "/web/classReport"
        //     },
        //      {
        //       title: "学生报告",
        //       path: "/web/studentReport"
        //     },
        //   ]
        // }
      ];
      this.current = this.getNavSate();
      this.getClass();
    });
  },
  watch: {
    nvaState(newVal) {
      this.current = newVal;
    }
  },
  computed: {
    nvaState() {
      return this.getNavSate();
    }
  },
  methods: {
    ...mapActions(["setState"]),
    ...mapGetters(["getNavSate"]),
    toggle(sindex, index, item) {
      this.current = [sindex, index];
      this.setState(this.current);
      let params = { path: item.path };
      if (sindex) {
        params.query = { index };
      }
      this.$router.push(params);
    },
    getClass() {
      fetch.grads({ userRole: 2 , exists: 1}).then(grads => {
        if (!grads) return false;
        let arr = [];
        for (let i = 0; i < grads.data.length; i++) {
          let item = grads.data[i];
          arr.push({
            title: item.className,
            path: "/web/classManage"
          });
        }
        this.navData.push({
          child: arr,
          title: "班级"
        });
      });
    }
  }
};
</script>




// WEBPACK FOOTER //
// navigation.vue?3971c52a